import {AsyncActionState} from '@telstra-connect/standard-actions/async-action'
import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  ILoadServicesActionAutoInt,
  ILoadServicesSuccessActionAutoInt,
  LoadServicesErrorActionAutoInt,
} from '../actions/load-services-int-auto'
import {IServicePerformanceState} from '../state'
import {initialState} from '../state/initial-state'

export type LoadServicesActionAutoInt =
  | ILoadServicesActionAutoInt
  | ILoadServicesSuccessActionAutoInt
  | LoadServicesErrorActionAutoInt

const init = (state: IServicePerformanceState, action: LoadServicesActionAutoInt) => ({
  ...state,
  servicesInt: {
    ...state.servicesInt,
    autoStatus: action.status,
    status: AsyncActionState.NotStarted,
  },
  putServiceReferenceInt: {
    ...initialState.putServiceReferenceInt,
    status: AsyncActionState.NotStarted,
  },
  serviceIdReferenceInt: null,
})

const success = (state: IServicePerformanceState, action: LoadServicesActionAutoInt) => {
  const localStateServices = (action as ILoadServicesSuccessActionAutoInt).data

  return {
    ...state,
    servicesInt: {
      ...initialState.servicesInt,
      autoStatus: action.status,
      data: {
        ...state.servicesInt.data,
        originalServices: [...localStateServices.originalServices],
      },
      status: AsyncActionState.NotStarted,
    },
    putServiceReferenceInt: {
      ...initialState.putServiceReferenceInt,
      status: AsyncActionState.NotStarted,
    },
    serviceIdReferenceInt: null,
  }
}

const failure = (state: IServicePerformanceState, action: LoadServicesActionAutoInt) => ({
  ...state,
  servicesInt: {
    ...initialState.servicesInt,
    autoStatus: action.status,
    error: (action as LoadServicesErrorActionAutoInt).error,
    status: AsyncActionState.NotStarted,
  },
  putServiceReferenceInt: {
    ...initialState.putServiceReferenceInt,
    status: AsyncActionState.NotStarted,
  },
  serviceIdReferenceInt: null,
})

export const loadServicesIntAutoReducer = createAsyncReducer(initialState, init, success, failure)
